
export const translations = {
    title:'Catálogos',
    menu: [{id:1, label:'Marcas'}, {id:2, label:'Tags'}, {id:3, label:'Categorías'}, 
            {id:4, label:'Subcategorías'}, {id:5, label:'Segmentos'}, {id:6, label:'Subsegmentos'} ],
}